import React, { useState } from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'lib/i18n'

import CtaButton from 'components/CtaButton/CtaButton'
import useSubscribeToChanges from 'hooks/useSubscribeToChanges'

import styles from './PotentialProfileMessageForm.module.css'

const { TextArea } = Input

export default function PotentialProfileMessageForm({ profile, email }) {
  const [done, setDone] = useState(false)
  const { t } = useTranslation()

  const [subscribe, { loading }] = useSubscribeToChanges({
    onCompleted: () => {
      setDone(true)
    },
  })

  const onFinish = (input) => {
    subscribe({ ...input, email, potentialProfileId: profile.id })
  }

  return (
    <Form onFinish={onFinish} layout="vertical">
      {done ? (
        <div className={styles.done}>
          <div className={styles.text}>
            {t(
              'PotentialProfileMessageForm.thanksText',
              'Thanks for your message, we are sure {{profileName}} will like it!',
              { profileName: profile.name },
            )}
          </div>
        </div>
      ) : (
        <div className={styles.text}>
          {t(
            'PotentialProfileMessageForm.text',
            'Give {{profileName}} a push! Let them know that you would like them here by sending a personalized message!',
            { profileName: profile.name },
          )}
        </div>
      )}

      {!done && (
        <div className={styles.fields}>
          <Form.Item
            name="message"
            id="message"
            rules={[
              {
                required: true,
                message: t(
                  'PotentialProfileMessageForm.messageRequired',
                  'Message is required',
                ),
              },
              {
                max: 250,
                message: t(
                  'PotentialProfileMessageForm.messageTooLong',
                  'Your message is a bit too long, please keep it below 250 characters',
                ),
              },
            ]}
          >
            <TextArea
              placeholder={t(
                'PotentialProfileMessageForm.messagePlaceholder',
                'Your message to {{profileName}}',
                { profileName: profile.name },
              )}
              style={{ minHeight: 130 }}
              disabled={loading}
            />
          </Form.Item>

          <CtaButton htmlType="submit" block disabled={loading} type="primary">
            {t('EmailSignupForm.cta', 'Submit')}
          </CtaButton>
        </div>
      )}
    </Form>
  )
}
